import { Sponsorstripe } from '@schibsted/advertory/aftenposten/cjs';
import React, { useEffect, useRef } from 'react';
import { MapProvider } from 'react-map-gl/maplibre';

import type { FrapiTeaserItem } from '../../../types/frapi-types.js';
import type { ListPageProps } from './index.js';

import {
  useByfunnPulseContext,
  buildListPageView,
} from '../../../pulse/index.js';
import Navigation from '../../components/commonComponents/Navigation/Navigation.js';
import { ListsProvider } from '../../components/saving/ListsProvider.js';
import { TopList } from './TopList/index.js';
import {
  getRelatedTopLists,
  toRelatedTopListTeaser,
} from './utils/related-top-list.js';
import { RenderContextProvider } from '../../contexts/RenderContext.js';

const ListPageV2: React.FC<ListPageProps> = ({ data, options }) => {
  const { siteVersion, isHermesApp, currentUrl } = options;
  const { properties, items } = data;

  const isMobile = siteVersion === 'phone';

  const ref = useRef<HTMLDivElement>(null);

  const { trackViewListing } = useByfunnPulseContext();

  useEffect(() => {
    const { legacy, tpaas } = buildListPageView({
      currentUrl,
      title: properties.h1,
      itemsTotal: items?.length ?? 0,
      topListVersion: 2,
    });

    trackViewListing(legacy, tpaas);
  }, [trackViewListing, currentUrl, properties.h1, items?.length]);

  const relatedTopLists = getRelatedTopLists(data.properties);
  const relatedTopListTeasers = relatedTopLists
    .slice(0, 2)
    .map((list) => toRelatedTopListTeaser(list, isMobile, 580, 768));

  return (
    <RenderContextProvider isHermesApp={isHermesApp} siteVersion={siteVersion}>
      <MapProvider>
        <ListsProvider>
          <div ref={ref} className={`${siteVersion}-front`}>
            <Navigation
              fullWidth={!isMobile}
              activeSection="restaurantguiden"
            />
            <Sponsorstripe targetId="sponsorstripe" />
            <TopList
              title={properties.h1}
              description={properties.description}
              teasers={items as FrapiTeaserItem[]}
              relatedTopListTeasers={relatedTopListTeasers}
            />
          </div>
        </ListsProvider>
      </MapProvider>
    </RenderContextProvider>
  );
};

export { ListPageV2 };
